import axios from '@/utils/axios'
import store from '@/store'

const loginHandle = ({ data: res }) => {
  store.commit('userInfo', res.data)
  if (res.data?.user?.oem_name) {
    document.title = res.data.user.oem_name
  }
  return { data: res }
}

// 用户登录校验
export const login = (fields, config) => {
  return axios.post('/Login/api_login_web', fields, config).then((res) => {
    const result = loginHandle(res)
    return result
  })
}

export const userinfo = (fields, config) => {
  return axios.post('/Api/userinfo', fields, config).then((res) => {
    const result = loginHandle(res)
    return result
  })
}

// 用户数据
export const loginout = (fields, config) => {
  return axios.post('/Api/loginout', fields, config)
}

export const leads_action_user_list = (fields, config) => {
  return axios.post('/Api/leads_action_user_list', fields, config)
}

export const leads_user_list_switch = (fields, config) => {
  return axios.post('/Api/leads_user_list_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const enterprise_video_comment = (fields, config) => {
  return axios.post('/Api/enterprise_video_comment', fields, config)
}

export const comment_manage = (fields, config) => {
  return axios.post('/Api/comment_manage', fields, config)
}

export const comment_manage_switch = (fields, config) => {
  return axios.post('/Api/comment_manage_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const reply_switch = (fields, config) => {
  return axios.post('/Api/reply_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const douyin_enter_im_switch = (fields, config) => {
  return axios.post('/Api/douyin_enter_im_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const rank = (fields, config) => {
  return axios.post('/Api/rank', fields, config)
}

export const course = (fields, config) => {
  return axios.post('/Api/course', fields, config)
}

export const business_ad = (fields, config) => {
  return axios.get('/Api/business_ad', fields, config)
}

export const get_system_setting_topic = (fields, config) => {
  return axios.get('/Api/system_setting_topic', fields, config)
}

export const system_setting_topic = (fields, config) => {
  return axios.post('/Api/system_setting_topic', fields, config)
}

export const system_setting_cluewords = (fields, config) => {
  return axios.post('/Api/system_setting_cluewords', fields, config)
}

export const system_setting_switch = (fields, config) => {
  return axios.post('/Api/system_setting_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const system_setting_user = (fields, config) => {
  return axios.post('/Api/system_setting_user', fields, config)
}

export const auth = (fields, config) => {
  return axios.post('/Api/auth', fields, config)
}

export const business_ad_bgb_consume = (fields, config) => {
  return axios.post('/Api/business_ad_bgb_consume', fields, config)
}

export const get_operation_data = (fields, config) => {
  return axios.post('/Api/operation_data', fields, config)
}

export const get_business_ad_dingxiang = (fields, config) => {
  return axios.post('/Api/business_ad_dingxiang', fields, config)
}

export const release_manage = (fields, config) => {
  return axios.post('/Api/releaseManage', fields, config)
}

export const article = (fields, config) => {
  return axios.get('/Api/article', fields, config)
}

export const auth_backup_list = (fields, config) => {
  return axios.post('/Api/auth_backup_list', fields, config)
}

export const ossconfig = () => axios.get('/Api/ossconfig')

export const v2_material = (fields, config) => {
  return axios.post('/Api/v2_material', fields, config)
}

export const v2_material_editor = (fields, config) => {
  return axios.post('/Api/v2_material_editor', fields, config)
}

export const v2_material_delete = (fields, config) => {
  return axios.post('/Api/v2_material_delete', fields, config)
}

export const v2_material_class = (fields, config) => {
  return axios.post('/Api/v2_material_class', fields, config)
}

export const v2_material_class_editor = (fields, config) => {
  return axios.post('/Api/v2_material_class_editor', fields, config)
}

export const v2_material_class_delete = (fields, config) => {
  return axios.post('/Api/v2_material_class_delete', fields, config)
}

export const v2_video_task = (fields, config) => {
  return axios.post('/Api/v2_video_task', fields, config)
}

export const v2_video_task_find = (fields, config) => {
  return axios.post('/Api/v2_video_task_find', fields, config)
}

export const v2_video_task_editor = (fields, config) => {
  return axios.post('/Api/v2_video_task_editor', fields, config)
}

export const v2_video = (fields, config) => {
  return axios.post('/Api/v2_video', fields, config)
}

export const v2_video_editor = (fields, config) => {
  return axios.post('/Api/v2_video_editor', fields, config)
}

export const v2_video_delete = (fields, config) => {
  return axios.post('/Api/v2_video_delete', fields, config)
}

export const v2_video_create = (fields, config) => {
  return axios.post('/Api/v2_video_create', fields, config)
}

export const v2_video_task_delete = (fields, config) => {
  return axios.post('/Api/v2_video_task_delete', fields, config)
}

export const v2_video_release = (fields, config) => {
  return axios.post('/Api/v2_video_release', fields, config)
}

export const v2_video_release_find = (fields, config) => {
  return axios.post('/Api/v2_video_release_find', fields, config)
}

export const v2_video_release_list = (fields, config) => {
  return axios.post('/Api/v2_video_release_list', fields, config)
}

export const v2_video_release_video = (fields, config) => {
  return axios.post('/Api/v2_video_release_video', fields, config)
}

export const smart_customer_acquisition = (fields, config) => {
  return axios.post('/Api/smart_customer_acquisition', fields, config)
}

export const task_sokey = (fields, config) => {
  return axios.post('/Api/task_sokey', fields, config)
}

export const task_crm = (fields, config) => {
  return axios.post('/Api/task_crm', fields, config)
}

export const task_plcrm = (fields, config) => {
  return axios.post('/Api/task_plcrm', fields, config)
}

export const task_adv_finance = (fields, config) => {
  return axios.post('/Api/task_adv_finance', fields, config)
}

export const task_qcy_finance = (fields, config) => {
  return axios.post('/Api/task_qcy_finance', fields, config)
}

export const task_plcrm_switch = (fields, config) => {
  return axios.post('/Api/task_plcrm_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const task_sokey_switch = (fields, config) => {
  return axios.post('/Api/task_sokey_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const billlist = (fields, config) => {
  return axios.post('/Api/billlist', fields, config)
}

export const task_crm_index = (fields, config) => {
  return axios.post('/Api/task_crm_index', fields, config)
}

export const v2_video_release_schema = (fields, config) => {
  return axios.post('/Api/v2_video_release_schema', fields, config)
}

export const douyin_rank_task_keyword = (fields, config) => {
  return axios.post('/Api/douyin_rank_task_keyword', fields, config)
}

export const douyin_rank_task_finance = (fields, config) => {
  return axios.post('/Api/douyin_rank_task_finance', fields, config)
}

export const douyin_rank_task_data = (fields, config) => {
  return axios.post('/Api/douyin_rank_task_data', fields, config)
}

export const message_push = (fields, config) => {
  return axios.post('/Api/message_push', fields, config)
}

export const message_push_switch = (fields, config) => {
  return axios.post('/Api/message_push_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const province_change = (fields, config) => {
  return axios.post('/Api/province_change', fields, config)
}

export const check_auth = (fields, config) => {
  return axios.post('/Api/check_auth', fields, config)
}

export const v2_video_task_bp_add = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_add', fields, config)
}

export const v2_video_task_bp_find = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_find', fields, config)
}

export const v2_video_task_bp_list = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_list', fields, config)
}

export const v2_video_task_bp_copy = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_copy', fields, config)
}

export const v2_video_task_bp_select = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_select', fields, config)
}

export const v2_video_task_batch_select = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_select', fields, config)
}

export const v2_video_release_schema_refresh = (fields, config) => {
  return axios.post('/Api/v2_video_release_schema_refresh', fields, config)
}

export const adlist = (fields, config) => {
  return axios.post('/Api/adlist', fields, config)
}

export const v2_video_release_video_delete = (fields, config) => {
  return axios.post('/Api/v2_video_release_video_delete', fields, config)
}

export const v2_video_release_video_find = (fields, config) => {
  return axios.post('/Api/v2_video_release_video_find', fields, config)
}

export const showvideo = (fields, config) => {
  return axios.post('/Api/showvideo', fields, config)
}

export const copy_video_title_area = (fields, config) => {
  return axios.post('/Api/copy_video_title_area', fields, config)
}

export const bg_material_list = (fields, config) => {
  return axios.post('/Api/bg_material_list', fields, config)
}

export const bg_material_add = (fields, config) => {
  return axios.post('/Api/bg_material_add', fields, config)
}

export const bg_material_delete = (fields, config) => {
  return axios.post('/Api/bg_material_delete', fields, config)
}

export const v2_video_task_batch_find = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_find', fields, config)
}

export const v2_video_task_batch_editor = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_editor', fields, config)
}

export const v2_video_task_batch_list = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_list', fields, config)
}

export const v2_video_task_batch_copy = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_copy', fields, config)
}

export const v2_video_task_batch_delete = (fields, config) => {
  return axios.post('/Api/v2_video_task_batch_delete', fields, config)
}

export const v2_video_task_bp_delete = (fields, config) => {
  return axios.post('/Api/v2_video_task_bp_delete', fields, config)
}

export const video_batch_task_template = (fields, config) => {
  return axios.post('/Api/video_batch_task_template', fields, config)
}

export const video_batch_task_template_create = (fields, config) => {
  return axios.post('/Api/video_batch_task_template_create', fields, config)
}

export const bilibli_type_list = (fields, config) => {
  return axios.post('/Api/bilibli_type_list', fields, config)
}

export const mix_list = (fields, config) => {
  return axios.post('/Api/mix_list', fields, config)
}

export const mix_add = (fields, config) => {
  return axios.post('/Api/mix_add', fields, config)
}

export const mix_del = (fields, config) => {
  return axios.post('/Api/mix_del', fields, config)
}

export const auth_option = (fields, config) => {
  return axios.get('/Api/auth_option', fields, config)
}

export const chatGPT = (fields, config) => {
  return axios.post('/Api/chatGPT', fields, config)
}

export const DeepSeekCheck = (fields, config) => {
  return axios.post('/Api/DeepSeekCheck', fields, config)
}

export const videoUploadHandleSingleTask = (fields, config) => {
  return axios.post('/Api/videoUploadHandleSingleTask', fields, config)
}

export const v2_video_title_generate = (fields, config) => {
  return axios.post('/Api/v2_video_title_generate', fields, config)
}

export const get_user_list_keywords = (fields, config) => {
  return axios.get('/Ajax/douyin_userlist_keywords', fields, config)
}

export const post_user_list_keywords = (fields, config) => {
  return axios.post('/Ajax/douyin_userlist_keywords', fields, config)
}

export const get_video_comment_keywords = (fields, config) => {
  return axios.get('/Ajax/douyin_video_comment_keywords', fields, config)
}

export const post_video_comment_keywords = (fields, config) => {
  return axios.post('/Ajax/douyin_video_comment_keywords', fields, config)
}

export const ajax_douyin_video_list = (fields, config) => {
  return axios.post('/Ajax/douyin_video_list', fields, config)
}

export const douyin_video_switch = (fields, config) => {
  return axios.post('/Ajax/douyin_video_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const ajax_douyin_fans_list = (fields, config) => {
  return axios.post('/Ajax/douyin_fans_list', fields, config)
}

export const ajax_douyin_following_list = (fields, config) => {
  return axios.post('/Ajax/douyin_following_list', fields, config)
}

export const leads_user_list = (fields, config) => {
  return axios.post('/Leads/userlist', fields, config)
}

export const leads_action_message_send = (fields, config) => {
  return axios.post('/LeadsAction/message_send', fields, config)
}

export const enterprise_leads_user_list = (fields, config) => {
  return axios.post('/Enterprise/leads_user_list', fields, config)
}

export const enterprise_log_list = (fields, config) => {
  return axios.post('/Enterprise/log_list', fields, config)
}

export const enterprise_comment_reply = (fields, config) => {
  return axios.post('/Enterprise/comment_reply', fields, config)
}

export const enterprise_video_data = (fields, config) => {
  return axios.post('/Enterprise/video_data', fields, config)
}

export const comment_manage_appeal = (fields, config) => {
  return axios.post('/CommentManage/appeal', fields, config)
}

export const comment_manage_cluewords_data_batch = (fields, config) => {
  return axios.post('/CommentManage/cluewords_data_batch', fields, config)
}

export const reply_index = (fields, config) => {
  return axios.post('/Reply/index', fields, config)
}

export const reply_editor = (fields, config) => {
  return axios.post('/Reply/editor', fields, config)
}

export const reply_douyin_reply_editor = (fields, config) => {
  return axios.post('/Reply/douyin_reply_editor', fields, config)
}

export const message_send = (fields, config) => {
  return axios.post('/MessageSend/index', fields, config)
}

export const message_send_edit = (fields, config) => {
  return axios.post('/MessageSend/edit', fields, config)
}

export const message_send_switch = (fields, config) => {
  return axios.post('/MessageSend/edit', fields, {
    disable_loading: true,
    ...config,
  })
}

export const douyin_enter_im = (fields, config) => {
  return axios.post('/DouyinEnterIm/index', fields, config)
}

export const douyin_enter_im_edit = (fields, config) => {
  return axios.post('/DouyinEnterIm/edit', fields, config)
}

export const business_ad_chart = (fields, config) => {
  return axios.post('/BusinessAd/chart', fields, config)
}

export const business_ad_bgbconsume = (fields, config) => {
  return axios.post('/BusinessAd/bgbconsume', fields, config)
}

export const business_ad_bgbtime = (fields, config) => {
  return axios.post('/BusinessAd/bgbtime', fields, config)
}

export const business_ad_bgbreclist = (fields, config) => {
  return axios.post('/BusinessAd/bgbreclist', fields, config)
}

export const system_setting_editor = (fields, config) => {
  return axios.post('/SystemSetting/editor', fields, config)
}

export const system_setting_delete = (fields, config) => {
  return axios.post('/SystemSetting/delete', fields, config)
}

export const system_setting_cluewords_relation_edit = (fields, config) => {
  return axios.post('/SystemSetting/cluewords_relation_edit', fields, config)
}

export const system_setting_user_editor = (fields, config) => {
  return axios.post('/SystemSetting/userEditor', fields, config)
}

export const system_setting_user_qsave_state = (fields, config) => {
  return axios.post('/SystemSetting/userQsaveState', fields, config)
}

export const system_setting_user_delete = (fields, config) => {
  return axios.post('/SystemSetting/userDelete', fields, config)
}

export const system_setting_cluewords_user_setting = (fields, config) => {
  return axios.post('/SystemSetting/cluewords_user_setting', fields, config)
}

export const system_setting_auth_info_editor = (fields, config) => {
  return axios.post('/SystemSetting/auth_info_editor', fields, config)
}

export const system_setting_cancel_auth = (fields, config) => {
  return axios.post('/SystemSetting/auth', fields, config)
}

export const system_setting_refresh_token = (fields, config) => {
  return axios.post('/SystemSetting/refresh_token', fields, config)
}

export const post_operation_data = (fields, config) => {
  return axios.post('/Operation/data', fields, config)
}

export const post_business_ad_dingxiang = (fields, config) => {
  return axios.post('/BusinessAd/dingxiang', fields, config)
}

export const data_center_account = (fields, config) => {
  return axios.post('/DataCenter/account', fields, config)
}

export const data_center_update_statistics = (fields, config) => {
  return axios.post('/DataCenter/update_statistics', fields, config)
}

export const video = (fields, config) => {
  return axios.post('/Video/index', fields, config)
}

export const video_video_list = (fields, config) => {
  return axios.post('/Video/video_list', fields, config)
}

export const video_release_video_manage = (fields, config) => {
  return axios.post('/Video/releaseVideoManage', fields, config)
}

export const video_auth_account_list_filter = (fields, config) => {
  return axios.post('/Video/auth_account_list_filter', fields, config)
}

export const video_select_video_poi = (fields, config) => {
  return axios.get('/Video/select_video_poi', fields, config)
}

export const video_poi_list = (fields, config) => {
  return axios.post('/Video/poi_list', fields, config)
}

export const video_poi = (fields, config) => {
  return axios.post('/Video/poi', fields, config)
}

export const video_poi_del = (fields, config) => {
  return axios.post('/Video/poi_del', fields, config)
}

export const video_poi_add = (fields, config) => {
  return axios.post('/Video/poi_add', fields, config)
}

export const report_form = (fields, config) => {
  return axios.post('/reportForm/index', fields, config)
}

// 首页 数据接口
export const index_data = (fields, config) => {
  return axios.get('/Api/index_data', fields, config)
}

// 修改密码的接口
export const index_password = (fields, config) => {
  return axios.post('/Index/password', fields, config)
}
// 定向投放 提交接口
export const toufang = (fields, config) => {
  return axios.post('/Allnetapi/toufang', fields, config)
}
// 微信二维码
export const wxurl = (fields, config) => {
  return axios.post('/Allnetapi/wxurl', fields, config)
}
// 检查微信
export const wxcheck = (fields, config) => {
  return axios.post('/Allnetapi/wxcheck', fields, config)
}

export const qr_code = (fields, config) => {
  return axios.get('/api/qr_code', fields, config)
}

export const qr_code_login = (fields, config) => {
  return axios.post('/api/qr_code_login', fields, config)
}

export const check_cookie = (fields, config) => {
  return axios.post('/api/check_cookie', fields, config)
}

export const send_code = (fields, config) => {
  return axios.post('/api/send_code', fields, config)
}

export const sumbit_code = (fields, config) => {
  return axios.post('/api/sumbit_code', fields, config)
}

export const sumbit_cookie = (fields, config) => {
  return axios.post('/api/sumbit_cookie', fields, config)
}

export const sumbit_video_cookie = (fields, config) => {
  return axios.post('/api/sumbit_video_cookie', fields, config)
}

export const check_video_cookie = (fields, config) => {
  return axios.post('/api/check_video_cookie', fields, config)
}

export const adlist_format = (fields, config) => {
  return axios.post('/api/adlist_format', fields, config)
}

export const v2_video_task_batch_edit_name = (fields, config) => {
  return axios.post('/api/v2_video_task_batch_edit_name', fields, config)
}

export const leads_action_list = (fields, config) => {
  return axios.post('/api/leads_action_list', fields, config)
}

export const im_message_send_post = (fields, config) => {
  return axios.post('/api/im_message_send_post', fields, config)
}

export const leads_action_user_list2 = (fields, config) => {
  return axios.post('/api/leads_action_user_list2', fields, config)
}

export const check_xiaohongshu_cookie = (fields, config) => {
  return axios.post('/api/check_xiaohongshu_cookie', fields, config)
}

export const yunjian_image_list = (fields, config) => {
  return axios.post('/api/yunjian_image_list', fields, config)
}

export const yunjian_image_add = (fields, config) => {
  return axios.post('/api/yunjian_image_add', fields, config)
}

export const yunjian_image_del = (fields, config) => {
  return axios.post('/api/yunjian_image_del', fields, config)
}

export const tool4_find = (fields, config) => {
  return axios.post('/api/tool4_find', fields, config)
}

export const douyin_exec_audio = (fields, config) => {
  return axios.post('/api/douyin_exec_audio', fields, config)
}

export const v2_video_release_stop = (fields, config) => {
  return axios.post('/api/v2_video_release_stop', fields, config)
}

export const v2_material_setting = (fields, config) => {
  return axios.post('/api/v2_material_setting', fields, config)
}

export const yjsclist = (fields, config) => {
  return axios.post('/Apiyjsucai/yjsclist', fields, config)
}

export const yjscget = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscget', fields, config)
}

export const yjscadd1 = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscadd1', fields, config)
}

export const yjscadd2 = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscadd2', fields, config)
}

export const cylistget = (fields, config) => {
  return axios.post('/Apiyjsucai/cylistget', fields, config)
}

export const cyadd = (fields, config) => {
  return axios.post('/Apiyjsucai/cyadd', fields, config)
}

export const cydit = (fields, config) => {
  return axios.post('/Apiyjsucai/cydit', fields, config)
}

export const cydel = (fields, config) => {
  return axios.post('/Apiyjsucai/cydel', fields, config)
}

export const cyprev = (fields, config) => {
  return axios.post('/Apiyjsucai/cyprev', fields, config)
}

export const jsclistget = (fields, config) => {
  return axios.post('/Apiyjsucai/jsclistget', fields, config)
}

export const jscadd = (fields, config) => {
  return axios.post('/Apiyjsucai/jscadd', fields, config)
}

export const jscedit = (fields, config) => {
  return axios.post('/Apiyjsucai/jscedit', fields, config)
}

export const jscdel = (fields, config) => {
  return axios.post('/Apiyjsucai/jscdel', fields, config)
}

export const jscprev = (fields, config) => {
  return axios.post('/Apiyjsucai/jscprev', fields, config)
}

export const getjscsyslist = (fields, config) => {
  return axios.post('/Apiyjsucai/getjscsyslist', fields, config)
}

export const sysjsctype = (fields, config) => {
  return axios.post('/Apiyjsucai/sysjsctype', fields, config)
}

export const yjscadd5 = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscadd5', fields, config)
}

export const yjscprev = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscprev', fields, config)
}

export const yjscdel = (fields, config) => {
  return axios.post('/Apiyjsucai/yjscdel', fields, config)
}

export const yjsccopy = (fields, config) => {
  return axios.post('/Apiyjsucai/yjsccopy', fields, config)
}

export const jscsystojsc = (fields, config) => {
  return axios.post('/Apiyjsucai/jscsystojsc', fields, config)
}

export const yjsctitle = (fields, config) => {
  return axios.post('/Apiyjsucai/yjsctitle', fields, config)
}

export const yjsclistall = (fields, config) => {
  return axios.post('/Apiyjsucai/yjsclistall', fields, config)
}

export const oem_info = (fields, config) => {
  return axios.post('/Login/oem_info', fields, config)
}

export const yunutoolsokey = (fields, config) => {
  return axios.post('/Api/yunutoolsokey', fields, config)
}

export const video_ai_task_select = (fields, config) => {
  return axios.post('/Api/video_ai_task_select', fields, config)
}

export const video_ai_task_switch = (fields, config) => {
  return axios.post('/Api/video_ai_task_switch', fields, config)
}

export const video_ai_task_delete = (fields, config) => {
  return axios.post('/Api/video_ai_task_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_copy = (fields, config) => {
  return axios.post('/Api/video_ai_task_copy', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_find = (fields, config) => {
  return axios.post('/Api/video_ai_task_find', fields, config)
}

export const video_ai_task_editor = (fields, config) => {
  return axios.post('/Api/video_ai_task_editor', fields, config)
}

export const video_ai_title_select = (fields, config) => {
  return axios.post('/Api/video_ai_title_select', fields, config)
}

export const video_ai_title_editor = (fields, config) => {
  return axios.post('/Api/video_ai_title_editor', fields, config)
}

export const video_ai_title_delete = (fields, config) => {
  return axios.post('/Api/video_ai_title_delete', fields, config)
}

export const video_ai_title_preview = (fields, config) => {
  return axios.post('/Api/video_ai_title_preview', fields, config)
}

export const video_ai_subtitle_select = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_select', fields, config)
}

export const video_ai_subtitle_editor = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_editor', fields, config)
}

export const video_ai_subtitle_delete = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_delete', fields, config)
}

export const video_ai_subtitle_sync = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_sync', fields, config)
}

export const video_ai_subtitle_template_use = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_template_use', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_preview = (fields, config) => {
  return axios.post('/Api/video_ai_task_preview', fields, config)
}

export const video_ai_cover_select = (fields, config) => {
  return axios.post('/Api/video_ai_cover_select', fields, config)
}

export const video_ai_cover_editor = (fields, config) => {
  return axios.post('/Api/video_ai_cover_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_cover_delete = (fields, config) => {
  return axios.post('/Api/video_ai_cover_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_cover_switch = (fields, config) => {
  return axios.post('/Api/video_ai_cover_switch', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_template_select = (fields, config) => {
  return axios.post('/Api/video_ai_template_select', fields, config)
}

export const video_ai_template_editor = (fields, config) => {
  return axios.post('/Api/video_ai_template_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_template_delete = (fields, config) => {
  return axios.post('/Api/video_ai_template_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_template_switch = (fields, config) => {
  return axios.post('/Api/video_ai_template_switch', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_cover_template = (fields, config) => {
  return axios.post('/Api/video_ai_task_cover_template', fields, config)
}

export const video_ai_task_template_template = (fields, config) => {
  return axios.post('/Api/video_ai_task_template_template', fields, config)
}

export const video_ai_material_scene_select = (fields, config) => {
  return axios.post('/Api/video_ai_material_scene_select', fields, config)
}

export const video_ai_material_scene_editor = (fields, config) => {
  return axios.post('/Api/video_ai_material_scene_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_material_scene_delete = (fields, config) => {
  return axios.post('/Api/video_ai_material_scene_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_material_add = (fields, config) => {
  return axios.post('/Api/video_ai_material_add', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_material_delete = (fields, config) => {
  return axios.post('/Api/video_ai_material_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const music_list = (fields, config) => {
  return axios.post('/Api/music_list', fields, config)
}

export const music_add = (fields, config) => {
  return axios.post('/Api/music_add', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const music_delete = (fields, config) => {
  return axios.post('/Api/music_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_intention_index = (fields, config) => {
  return axios.post('/Api/user_intention_index', fields, config)
}

export const user_intention_list = (fields, config) => {
  return axios.post('/Api/user_intention_list', fields, config)
}

export const user_intention_list_switch = (fields, config) => {
  return axios.post('/Api/user_intention_list_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const user_intention_edit = (fields, config) => {
  return axios.post('/Api/user_intention_edit', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_intention_record = (fields, config) => {
  return axios.post('/Api/user_intention_record', fields, config)
}

export const user_intention_card = (fields, config) => {
  return axios.post('/Api/user_intention_card', fields, config)
}

export const user_intention_card_editor = (fields, config) => {
  return axios.postForm('/Api/user_intention_card_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_intention_record_index = (fields, config) => {
  return axios.post('/Api/user_intention_record_index', fields, config)
}

export const user_intention_reply_list = (fields, config) => {
  return axios.post('/Api/user_intention_reply_list', fields, config)
}

export const user_intention_reply_list_switch = (fields, config) => {
  return axios.post('/Api/user_intention_reply_list_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const user_intention_reply_editor = (fields, config) => {
  return axios.post('/Api/user_intention_reply_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_intention_reply_delete = (fields, config) => {
  return axios.post('/Api/user_intention_reply_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_intention = (fields, config) => {
  return axios.post('/Api/user_intention', fields, config)
}

export const user_intention_dialogu = (fields, config) => {
  return axios.post('/Api/user_intention_dialogu', fields, config)
}

export const im_send_msg = (fields, config) => {
  return axios.post('/Api/im_send_msg', fields, config)
}

export const video_item_comment = (fields, config) => {
  return axios.post('/Api/video_item_comment', fields, config)
}

export const item_comment_top = (fields, config) => {
  return axios.post('/Api/item_comment_top', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_comment_reply = (fields, config) => {
  return axios.post('/Api/video_comment_reply', fields, config)
}

export const v2_video_new_release = (fields, config) => {
  return axios.post('/Api/v2_video_new_release', fields, config)
}

export const v2_video_new_release_find = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_find', fields, config)
}

export const v2_video_new_release_list = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_list', fields, config)
}

export const v2_video_new_release_stop = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_stop', fields, config)
}

export const v2_video_new_release_video = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_video', fields, config)
}

export const v2_video_new_release_video_delete = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_video_delete', fields, config)
}

export const videoNewUploadHandleSingleTask = (fields, config) => {
  return axios.post('/Api/videoNewUploadHandleSingleTask', fields, config)
}

export const v2_video_new_release_video_stop = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_video_stop', fields, config)
}

export const v2_video_new_release_video_update = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_video_update', fields, config)
}

export const v2_video_new_release_video_iframe = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_video_iframe', fields, config)
}

export const new_auth = (fields, config) => {
  return axios.post('/Api/new_auth', fields, config)
}

export const new_index_data = (fields, config) => {
  return axios.post('/Api/new_index_data', fields, config)
}

export const v2_video_new_release_task_state = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_task_state', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const new_index_count = (fields, config) => {
  return axios.post('/Api/new_index_count', fields, config)
}

export const v2_video_new_release_submit = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_submit', fields, config)
}

export const v2_video_new_release_delete = (fields, config) => {
  return axios.post('/Api/v2_video_new_release_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const report_form_count = (fields, config) => {
  return axios.post('/reportForm/report_form_count', fields, config)
}

export const report_form_user_intention_list = (fields, config) => {
  return axios.post('/reportForm/user_intention_list', fields, config)
}

export const report_form_douyin_keywords_rank_data = (fields, config) => {
  return axios.post('/reportForm/douyin_keywords_rank_data', fields, config)
}

export const report_form_douyin_rank_task_data = (fields, config) => {
  return axios.post('/reportForm/douyin_rank_task_data', fields, config)
}

export const video_ai_task_enum = (fields, config) => {
  return axios.post('/Api/video_ai_task_enum', fields, config)
}

export const video_ai_task_manual = (fields, config) => {
  return axios.post('/Api/video_ai_task_manual', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_group = (fields, config) => {
  return axios.post('/Api/video_ai_task_group', fields, config)
}

export const video_ai_task_background_template = (fields, config) => {
  return axios.post('/Api/video_ai_task_background_template', fields, config)
}

export const video_ai_task_subtitle_variable = (fields, config) => {
  return axios.post('/Api/video_ai_task_subtitle_variable', fields, config)
}

export const video_ai_task_subtitle_variable_editor = (fields, config) => {
  return axios.post('/Api/video_ai_task_subtitle_variable_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_group_retask = (fields, config) => {
  return axios.post('/Api/video_ai_task_group_retask', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_video_task_ai_select = (fields, config) => {
  return axios.post('/Api/v2_video_task_ai_select', fields, config)
}

export const video_ai_step_validate = (fields, config) => {
  return axios.post('/Api/video_ai_step_validate', fields, config)
}

export const video_ai_task_pinyin_list = (fields, config) => {
  return axios.post('/Api/video_ai_task_pinyin_list', fields, config)
}

export const video_ai_task_pinyin_delete = (fields, config) => {
  return axios.post('/Api/video_ai_task_pinyin_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_pinyin_editor = (fields, config) => {
  return axios.post('/Api/video_ai_task_pinyin_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const pinyin = (fields, config) => {
  return axios.post('/Api/pinyin', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const mount_list = (fields, config) => {
  return axios.post('/Api/mount_list', fields, config)
}

export const mount_delete = (fields, config) => {
  return axios.post('/Api/mount_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const mount_editor = (fields, config) => {
  return axios.post('/Api/mount_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_queue = (fields, config) => {
  return axios.post('/Api/video_ai_task_queue', fields, config)
}

export const image_text_task_find = (fields, config) => {
  return axios.post('/Api/image_text_task_find', fields, config)
}

export const image_text_task_editor = (fields, config) => {
  return axios.post('/Api/image_text_task_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const image_text_task_list = (fields, config) => {
  return axios.post('/Api/image_text_task_list', fields, config)
}

export const image_text_task_stop = (fields, config) => {
  return axios.post('/Api/image_text_task_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const image_text_queue_list = (fields, config) => {
  return axios.post('/Api/image_text_queue_list', fields, config)
}

export const image_text_task_preview = (fields, config) => {
  return axios.post('/Api/image_text_task_preview', fields, config)
}

export const douyin_music_list = (fields, config) => {
  return axios.post('/Api/douyin_music_list', fields, config)
}

export const image_text_task_delete = (fields, config) => {
  return axios.post('/Api/image_text_task_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const image_text_task_copy = (fields, config) => {
  return axios.post('/Api/image_text_task_copy', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const haokan_getQrcode = (fields, config) => {
  return axios.post('/Api/haokan_getQrcode', fields, config)
}

export const haokan_checkQrcode = (fields, config) => {
  return axios.post('/Api/haokan_checkQrcode', fields, {
    disable_loading: true,
    ...config,
  })
}

export const haokan_pubvideo = (fields, config) => {
  return axios.post('/Api/haokan_pubvideo', fields, config)
}

export const toutiao_getQrcode = (fields, config) => {
  return axios.post('/Api/toutiao_getQrcode', fields, config)
}

export const toutiao_checkQrcode = (fields, config) => {
  return axios.post('/Api/toutiao_checkQrcode', fields, {
    disable_loading: true,
    ...config,
  })
}

export const toutiao_pubvideo = (fields, config) => {
  return axios.post('/Api/toutiao_pubvideo', fields, config)
}

export const douyin_user_list = (fields, config) => {
  return axios.post('/Api/douyin_user_list', fields, config)
}

export const douyin_user_list_sync = (fields, config) => {
  return axios.post('/Api/douyin_user_list_sync', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const mix_item_list = (fields, config) => {
  return axios.post('/Api/mix_item_list', fields, config)
}

export const mix_editlist = (fields, config) => {
  return axios.post('/Api/mix_editlist', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const mix_item = (fields, config) => {
  return axios.post('/Api/mix_item', fields, config)
}

export const tool_image_template_select = (fields, config) => {
  return axios.post('/Api/tool_image_template_select', fields, config)
}

export const tool_image_template_editor = (fields, config) => {
  return axios.post('/Api/tool_image_template_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const tool_image_template_template = (fields, config) => {
  return axios.post('/Api/tool_image_template_template', fields, config)
}

export const tool_image_template_delete = (fields, config) => {
  return axios.post('/Api/tool_image_template_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const tool_image_task = (fields, config) => {
  return axios.post('/Api/tool_image_task', fields, {
    disable_loading: true,
    ...config,
  })
}

export const oss_zip = (fields, config) => {
  return axios.post('/Api/oss_zip', fields, {
    responseType: 'blob',
    ...config,
  })
}

// 特有
export const report_form_index_data = (fields, config) => {
  return axios.post('/reportForm/index_data', fields, config)
}

export const accurate_setting_find = (fields, config) => {
  return axios.post('/api/accurate_setting_find', fields, config)
}

export const accurate_setting_preview = (fields, config) => {
  return axios.post('/api/accurate_setting_preview', fields, config)
}

export const accurate_setting_edit = (fields, config) => {
  return axios.post('/api/accurate_setting_edit', fields, config)
}

export const accurate_keywords = (fields, config) => {
  return axios.post('/api/accurate_keywords', fields, config)
}

export const accurate_data = (fields, config) => {
  return axios.post('/api/accurate_data', fields, config)
}

export const accurate_finance = (fields, config) => {
  return axios.post('/api/accurate_finance', fields, config)
}

export const video_auth_account_list = (fields, config) => {
  return axios.post('/Video/auth_account_list', fields, config)
}

export const douyin_shop_list = (fields, config) => {
  return axios.post('/Api/douyin_shop_list', fields, config)
}

export const douyin_shop_delete = (fields, config) => {
  return axios.post('/Api/douyin_shop_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const douyin_shop_editor = (fields, config) => {
  return axios.post('/Api/douyin_shop_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const leads_product_list = (fields, config) => {
  return axios.post('/ApiSaiyan/leads_product_list', fields, config)
}

export const tool_item_list = (fields, config) => {
  return axios.post('/ApiSaiyan/tool_item_list', fields, config)
}

export const item_bind = (fields, config) => {
  return axios.post('/ApiSaiyan/item_bind', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const hot_video = (fields, config) => {
  return axios.post('/Api/hot_video', fields, config)
}

export const hot_video_task_create = (fields, config) => {
  return axios.post('/Api/hot_video_task_create', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const hot_video_task = (fields, config) => {
  return axios.post('/Api/hot_video_task', fields, config)
}

export const auth_cookie_check = (fields, config) => {
  return axios.get('/Api/auth_cookie_check', fields, config)
}

export const contactcard_editor = (fields, config) => {
  return axios.post('/Api/contactcard_editor', fields, config)
}

export const orderuserindex = (fields, config) => {
  return axios.post('/Api/orderuserindex', fields, config)
}

export const orderuserqrcode = (fields, config) => {
  return axios.post('/Api/orderuserqrcode', fields, config)
}

export const orderusercheckqrcode = (fields, config) => {
  return axios.post('/Api/orderusercheckqrcode', fields, config)
}

export const orderuseradd = (fields, config) => {
  return axios.post('/Api/orderuseradd', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const orderuserswitch = (fields, config) => {
  return axios.post('/Api/orderuserswitch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const orderuserdel = (fields, config) => {
  return axios.post('/Api/orderuserdel', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_release_find = (fields, config) => {
  return axios.post('/Api/video_ai_task_release_find', fields, config)
}

export const video_ai_task_release = (fields, config) => {
  return axios.post('/Api/video_ai_task_release', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_task_release_switch = (fields, config) => {
  return axios.post('/Api/video_ai_task_release_switch', fields, config)
}

export const auth_info_group_list = (fields, config) => {
  return axios.post('/Api/auth_info_group_list', fields, config)
}

export const auth_info_group_editor = (fields, config) => {
  return axios.post('/Api/auth_info_group_editor', fields, config)
}

export const auth_info_group_delete = (fields, config) => {
  return axios.post('/Api/auth_info_group_delete', fields, config)
}

export const auth_info_group_auth_list = (fields, config) => {
  return axios.post('/Api/auth_info_group_auth_list', fields, config)
}

export const auth_info_group_auth_editor = (fields, config) => {
  return axios.post('/Api/auth_info_group_auth_editor', fields, config)
}

export const v2_video_title_keywords_generate = (fields, config) => {
  return axios.post('/Api/v2_video_title_keywords_generate', fields, config)
}

export const v3_video_release = (fields, config) => {
  return axios.post('/Api/v3_video_release', fields, config)
}

export const v3_video_release_preview = (fields, config) => {
  return axios.post('/Api/v3_video_release_preview', fields, config)
}

export const v3_video_release_find = (fields, config) => {
  return axios.post('/Api/v3_video_release_find', fields, config)
}

export const v3_video_release_list = (fields, config) => {
  return axios.post('/Api/v3_video_release_list', fields, config)
}

export const v3_video_release_submit = (fields, config) => {
  return axios.post('/Api/v3_video_release_submit', fields, config)
}

export const v3_video_release_delete = (fields, config) => {
  return axios.post('/Api/v3_video_release_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v3_video_release_stop = (fields, config) => {
  return axios.post('/Api/v3_video_release_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}
export const v3_video_release_queue_list = (fields, config) => {
  return axios.post('/Api/v3_video_release_queue_list', fields, config)
}

export const v3_video_release_queue_count_check = (fields, config) => {
  return axios.post('/Api/v3_video_release_queue_count_check', fields, config)
}

export const v3_video_release_queue_stop = (fields, config) => {
  return axios.post('/Api/v3_video_release_queue_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const auth_info_group_select_list = (fields, config) => {
  return axios.post('/Api/auth_info_group_select_list', fields, config)
}

export const auth_info_group_auth_select_list = (fields, config) => {
  return axios.post('/Api/auth_info_group_auth_select_list', fields, config)
}

export const v3_video_release_queue_repeat = (fields, config) => {
  return axios.post('/Api/v3_video_release_queue_repeat', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_material_class_list = (fields, config) => {
  return axios.post('/Api/v2_material_class_list', fields, config)
}

export const auth_info_mount_edit = (fields, config) => {
  return axios.post('/Api/auth_info_mount_edit', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const keywords_list = (fields, config) => {
  return axios.post('/Api/keywords_list', fields, config)
}

export const keywords_delete = (fields, config) => {
  return axios.post('/Api/keywords_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const keywords_editor = (fields, config) => {
  return axios.post('/Api/keywords_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const keywords_preview = (fields, config) => {
  return axios.post('/Api/keywords_preview', fields, config)
}

export const keywords_related_words = (fields, config) => {
  return axios.post('/Api/keywords_related_words', fields, config)
}

export const video_ai_v3_auto_release_find = (fields, config) => {
  return axios.post('/Api/video_ai_v3_auto_release_find', fields, config)
}

export const video_ai_v3_auto_release = (fields, config) => {
  return axios.post('/Api/video_ai_v3_auto_release', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_v3_auto_release_switch = (fields, config) => {
  return axios.post('/Api/video_ai_v3_auto_release_switch', fields, config)
}

export const v3_video_release_queue_batch_update = (fields, config) => {
  return axios.post('/Api/v3_video_release_queue_batch_update', fields, config)
}

export const v3_video_single_release = (fields, config) => {
  return axios.post('/Api/v3_video_single_release', fields, config)
}

export const v3_video_single_release_preview = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_preview', fields, config)
}

export const v3_video_single_release_find = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_find', fields, config)
}

export const v3_video_single_release_list = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_list', fields, config)
}

export const v3_video_single_release_submit = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_submit', fields, config)
}

export const v3_video_single_release_delete = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v3_video_single_release_stop = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}
export const v3_video_single_release_queue_list = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_queue_list', fields, config)
}

export const v3_video_single_release_queue_count_check = (fields, config) => {
  return axios.post(
    '/Api/v3_video_single_release_queue_count_check',
    fields,
    config,
  )
}

export const v3_video_single_release_queue_stop = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_queue_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v3_video_single_release_queue_repeat = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_queue_repeat', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v3_video_single_release_queue_batch_update = (fields, config) => {
  return axios.post(
    '/Api/v3_video_single_release_queue_batch_update',
    fields,
    config,
  )
}

export const v3_video_single_release_batch_preview = (fields, config) => {
  return axios.post(
    '/Api/v3_video_single_release_batch_preview',
    fields,
    config,
  )
}

export const v3_video_single_release_batch_submit = (fields, config) => {
  return axios.post('/Api/v3_video_single_release_batch_submit', fields, config)
}

export const v2_image_text_template_class_list = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_class_list', fields, config)
}

export const v2_image_text_template_class_editor = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_class_editor', fields, config)
}

export const v2_image_text_template_class_delete = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_class_delete', fields, config)
}

export const v2_image_text_template_list = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_list', fields, config)
}

export const v2_image_text_template_delete = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_delete', fields, config)
}

export const v2_image_text_template_class = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_class', fields, config)
}

export const v2_image_text_template_setting = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_setting', fields, config)
}

export const v2_image_text_template_template = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_template', fields, config)
}

export const v2_image_text_template_editor = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_image_text_task_list = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_list', fields, config)
}

export const v2_image_text_task_stop = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_stop', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_image_text_task_copy = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_copy', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_image_text_task_delete = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_image_text_task_find = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_find', fields, config)
}

export const v2_image_text_task_editor = (fields, config) => {
  return axios.post('/Api/v2_image_text_task_editor', fields, config)
}

export const v2_image_text_queue_list = (fields, config) => {
  return axios.post('/Api/v2_image_text_queue_list', fields, config)
}

export const v2_image_text_template_find = (fields, config) => {
  return axios.post('/Api/v2_image_text_template_find', fields, config)
}

export const v2_image_text_task_release_time_preview = (fields, config) => {
  return axios.post(
    '/Api/v2_image_text_task_release_time_preview',
    fields,
    config,
  )
}

export const v2_material_checked_size = (fields, config) => {
  return axios.post('/Api/v2_material_checked_size', fields, config)
}

export const get_v2_material_size = (fields, config) => {
  return axios.get('/Api/get_v2_material_size', fields, config)
}

export const v2_material_recycle = (fields, config) => {
  return axios.post('/Api/v2_material_recycle', fields, config)
}

export const v2_material_recycle_delete = (fields, config) => {
  return axios.post('/Api/v2_material_recycle_delete', fields, config)
}

export const v2_video_class = (fields, config) => {
  return axios.post('/Api/v2_video_class', fields, config)
}

export const v2_video_class_list = (fields, config) => {
  return axios.post('/Api/v2_video_class_list', fields, config)
}

export const v2_video_class_editor = (fields, config) => {
  return axios.post('/Api/v2_video_class_editor', fields, config)
}

export const v2_video_class_delete = (fields, config) => {
  return axios.post('/Api/v2_video_class_delete', fields, config)
}

export const v2_video_setting = (fields, config) => {
  return axios.post('/Api/v2_video_setting', fields, config)
}

export const shipinhao_getQrcode = (fields, config) => {
  return axios.post('/Api/shipinhao_getQrcode', fields, config)
}

export const shipinhao_checkQrcode = (fields, config) => {
  return axios.post('/Api/shipinhao_checkQrcode', fields, {
    disable_loading: true,
    ...config,
  })
}

export const xhs_getQrcode = (fields, config) => {
  return axios.post('/Api/xhs_getQrcode', fields, config)
}

export const xhs_checkQrcode = (fields, config) => {
  return axios.post('/Api/xhs_checkQrcode', fields, {
    disable_loading: true,
    ...config,
  })
}

export const sendsms = (fields, config) => {
  return axios.post('/Api/sendsms', fields, config)
}

export const putsms = (fields, config) => {
  return axios.post('/Api/putsms', fields, config)
}

export const update_video_list = (fields, config) => {
  return axios.post('/Api/update_video_list', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const check_login = (fields, config) => {
  return axios.post('/Api/check_login', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const report_forms_week = (fields, config) => {
  return axios.post('/Api/report_forms_week', fields, config)
}

export const report_forms_week_find = (fields, config) => {
  return axios.post('/reportForm/report_forms_week_find', fields, config)
}

export const qyhsheet = (fields, config) => {
  return axios.post('/ApiTool/qyhsheet', fields, config)
}

export const datatexta = (fields, config) => {
  return axios.post('/ApiTool/datatexta', fields, config)
}

export const datatextb = (fields, config) => {
  return axios.post('/ApiTool/datatextb', fields, config)
}

export const datatextc = (fields, config) => {
  return axios.post('/ApiTool/datatextc', fields, config)
}

export const qydetail = (fields, config) => {
  return axios.post('/ApiTool/qydetail', fields, config)
}

export const ApiTool_userinfo = (fields, config) => {
  return axios.post('/ApiTool/userinfo', fields, config)
}

export const seven_seconds_list = (fields, config) => {
  return axios.post('/Api/seven_seconds_list', fields, config)
}

export const v2_video_count_check = (fields, config) => {
  return axios.post('/Api/v2_video_count_check', fields, config)
}

export const seven_seconds_editor = (fields, config) => {
  return axios.post('/Api/seven_seconds_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const seven_seconds_find = (fields, config) => {
  return axios.post('/Api/seven_seconds_find', fields, config)
}

export const seven_seconds_delete = (fields, config) => {
  return axios.post('/Api/seven_seconds_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const seven_seconds_queue = (fields, config) => {
  return axios.post('/Api/seven_seconds_queue', fields, config)
}

export const seven_seconds_copy = (fields, config) => {
  return axios.post('/Api/seven_seconds_copy', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const copywriting_find = (fields, config) => {
  return axios.post('/Api/copywriting_find', fields, config)
}

export const seven_seconds_edit = (fields, config) => {
  return axios.post('/Api/seven_seconds_edit', fields, {
    messageSuccess: true,
    ...config,
  })
}
export const bg_audio_muisc_find = (fields, config) => {
  return axios.post('/Api/bg_audio_muisc_find', fields, config)
}

export const copywriting_industry_data = (fields, config) => {
  return axios.post('/Api/copywriting_industry_data', fields, config)
}

export const copywriting_selection_batch_add = (fields, config) => {
  return axios.post('/Api/copywriting_selection_batch_add', fields, config)
}

export const article_list = (fields, config) => {
  return axios.post('/Api/article_list', fields, config)
}

export const article_look = (fields, config) => {
  return axios.post('/Api/article_look', fields, {
    disable_loading: true,
    ...config,
  })
}

export const copywriting_class_list = (fields, config) => {
  return axios.post('/Api/copywriting_class_list', fields, config)
}

export const copywriting_class_editor = (fields, config) => {
  return axios.post('/Api/copywriting_class_editor', fields, config)
}

export const copywriting_class_delete = (fields, config) => {
  return axios.post('/Api/copywriting_class_delete', fields, config)
}

export const copywriting_class = (fields, config) => {
  return axios.post('/Api/copywriting_class', fields, config)
}

export const copywriting_list = (fields, config) => {
  return axios.post('/Api/copywriting_list', fields, config)
}

export const copywriting_config = (fields, config) => {
  return axios.post('/Api/copywriting_config', fields, config)
}

export const copywriting_setting = (fields, config) => {
  return axios.post('/Api/copywriting_setting', fields, config)
}

export const copywriting_config_editor = (fields, config) => {
  return axios.post('/Api/copywriting_config_editor', fields, config)
}

export const copywriting_industry_class = (fields, config) => {
  return axios.post('/Api/copywriting_industry_class', fields, config)
}

export const copywriting_batch_add = (fields, config) => {
  return axios.post('/Api/copywriting_batch_add', fields, config)
}

export const copywriting_delete = (fields, config) => {
  return axios.post('/Api/copywriting_delete', fields, config)
}

export const copywriting_editor = (fields, config) => {
  return axios.post('/Api/copywriting_editor', fields, config)
}

export const update_nickname = (fields, config) => {
  return axios.post('/Api/update_nickname', fields, config)
}

export const update_fans_count = (fields, config) => {
  return axios.post('/Api/update_fans_count', fields, config)
}

export const edit_fans_count = (fields, config) => {
  return axios.post('/Api/edit_fans_count', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const checked_mcn_auth = (fields, config) => {
  return axios.post('/Api/checked_mcn_auth', fields, config)
}

export const mcn_ck_update = (fields, config) => {
  return axios.post('/Api/mcn_ck_update', fields, config)
}

export const itfaba = (fields, config) => {
  return axios.post('/Api/itfaba', fields, config).then((res) => res.data)
}

export const check_login2 = (fields, config) => {
  return axios.post('/Api/check_login2', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const user_is_douyin_release = (fields, config) => {
  return axios.get('/Api/user_is_douyin_release', fields, config)
}

export const v2_image_text_queue_restart = (fields, config) => {
  return axios.post('/Api/v2_image_text_queue_restart', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const v2_material_recycle_restore = (fields, config) => {
  return axios.post('/Api/v2_material_recycle_restore', fields, config)
}

export const tandianma_task = (fields, config) => {
  return axios.post('/Api/tandianma_task', fields, config)
}

export const tandianma_task_create_check = (fields, config) => {
  return axios.post('/Api/tandianma_task_create_check', fields, config)
}

export const tandianma_task_switch = (fields, config) => {
  return axios.post('/Api/tandianma_task_switch', fields, {
    disable_loading: true,
    ...config,
  })
}

export const tandianma_store = (fields, config) => {
  return axios.post('/Api/tandianma_store', fields, config)
}

export const tandianma_store_delete = (fields, config) => {
  return axios.post('/Api/tandianma_store_delete', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const tandianma_store_editor = (fields, config) => {
  return axios.post('/Api/tandianma_store_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const tandianma_task_create = (fields, config) => {
  return axios.post('/Api/tandianma_task_create', fields, config)
}

export const tandianma_video_push = (fields, config) => {
  return axios.post('/Api/tandianma_video_push', fields, config)
}

export const tandianma_video = (fields, config) => {
  return axios.post('/Api/tandianma_video', fields, config)
}

export const tandianma_video_edit = (fields, config) => {
  return axios.post('/Api/tandianma_video_edit', fields, config)
}

export const tandianma_video_del = (fields, config) => {
  return axios.post('/Api/tandianma_video_del', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const tandianma_task_edit = (fields, config) => {
  return axios.post('/Api/tandianma_task_edit', fields, config)
}

export const tandianma_qrcode = (fields, config) => {
  return axios.post('/Api/tandianma_qrcode', fields, config)
}

export const tandianma_video_update = (fields, config) => {
  return axios.post('/Api/tandianma_video_update', fields, config)
}

export const tandianma_video_statistics = (fields, config) => {
  return axios.post('/Api/tandianma_video_statistics', fields, config)
}

export const privatemessage_manage = (fields, config) => {
  return axios.post('/Api/privatemessage_manage', fields, config)
}

export const privatemessage_dialogue = (fields, config) => {
  return axios.post('/Api/privatemessage_dialogue', fields, config)
}

export const sendMessage = (fields, config) => {
  return axios.post('/Api/sendMessage', fields, config)
}

export const video_new_release_detailed_chart = (fields, config) => {
  return axios.post('/Api/video_new_release_detailed_chart', fields, config)
}

export const comment_data = (fields, config) => {
  return axios.post('/Api/comment_data', fields, config)
}

export const v2publishcomment = (fields, config) => {
  return axios.post('/Api/v2publishcomment', fields, config)
}

export const v2deletecomment = (fields, config) => {
  return axios.post('/Api/v2deletecomment', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const comment_video_data_find = (fields, config) => {
  return axios.post('/Api/comment_video_data_find', fields, config)
}

export const table_article_task = (fields, config) => {
  return axios.post('/Api/table_article_task', fields, config)
}

export const bzasone_rank = (fields, config) => {
  return axios.post('/Api/bzasone_rank', fields, config)
}

export const article_task_pause = (fields, config) => {
  return axios.post('/Api/article_task_pause', fields, config)
}

export const article_task_del = (fields, config) => {
  return axios.post('/Api/article_task_del', fields, config)
}

export const componentlist = (fields, config) => {
  return axios.post('/ApiArticle/componentlist', fields, config)
}

export const checklogin = (fields, config) => {
  return axios.post('/ApiArticle/checklogin', fields, config)
}

export const article_component_create = (fields, config) => {
  return axios.post('/Api/article_component_create', fields, config)
}

export const article_queue_switch = (fields, config) => {
  return axios.post('/Api/article_queue_switch', fields, config)
}

export const article_queue_edit = (fields, config) => {
  return axios.post('/Api/article_queue_edit', fields, config)
}

export const article_image_add = (fields, config) => {
  return axios.post('/Api/article_image_add', fields, config)
}

export const uploadimage = (fields, config) => {
  return axios.post('/ApiArticle/uploadimage', fields, config)
}

export const article_image_delete = (fields, config) => {
  return axios.post('/Api/article_image_delete', fields, config)
}

export const article_image_list = (fields, config) => {
  return axios.post('/Api/article_image_list', fields, config)
}

export const article_queue_find = (fields, config) => {
  return axios.post('/Api/article_queue_find', fields, config)
}

export const article_task_queue_repeat = (fields, config) => {
  return axios.post('/Api/article_task_queue_repeat', fields, config)
}

export const article_task_queue_list = (fields, config) => {
  return axios.post('/Api/article_task_queue_list', fields, config)
}

export const article_task_editor = (fields, config) => {
  return axios.post('/Api/article_task_editor', fields, config)
}

export const auth_info_list = (fields, config) => {
  return axios.post('/Api/auth_info_list', fields, config)
}

export const article_task_find = (fields, config) => {
  return axios.post('/Api/article_task_find', fields, config)
}

export const account_limit = (fields, config) => {
  return axios.post('/Api/account_limit', fields, config)
}

export const article_limit = (fields, config) => {
  return axios.post('/Api/article_limit', fields, config)
}

export const sora2_table = (fields, config) => {
  return axios.post('/Api/sora2_table', fields, config)
}

export const sora2_create = (fields, config) => {
  return axios.post('/Api/sora2_create', fields, config)
}

export const sora2_limit = (fields, config) => {
  return axios.post('/Api/sora2_limit', fields, config)
}

export const video_ai_title_batch_add = (fields, config) => {
  return axios.post('/Api/video_ai_title_batch_add', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_batch_replace_editor = (fields, config) => {
  return axios.post('/Api/video_ai_batch_replace_editor', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const video_ai_subtitle_batch_add = (fields, config) => {
  return axios.post('/Api/video_ai_subtitle_batch_add', fields, {
    messageSuccess: true,
    ...config,
  })
}

export const douyin_rank_task_keyword_ck_update = (fields, config) => {
  return axios.post('/Api/douyin_rank_task_keyword_ck_update', fields, config)
}
export default axios
